import {Button, FlipList, Icon } from '@startlibs/components';
import React, {useContext, useEffect} from 'react'
import {
  PanelButton,
  WidgetBody,
  WidgetFooter,
  WidgetHeader,
  WidgetPanelComponent
} from './PanelStyles';
import {touchClick} from './utils'
import {usePanelUtils2} from './usePanelUtils2'
import { SelectingItem } from './SelectingItem';
import { DicomRouterContext } from '../../utils/DicomRouterContext';
import styled, {css} from 'styled-components'

const WidgetIcon = styled(Icon)`
  font-size: 33px !important;
  line-height: 21px !important;
  margin-right: 1.25rem !important;
`
const RouteWidgetFooter = styled(WidgetFooter)`
  display: flex;
  ${Button} {
    flex-grow: 1;
  }
`

export const SelectToRoutePanel = ({close, togglePacsDialog}) => {

  const {selectedStudiesToRoute, setSelectedStudiesToRoute} = useContext(DicomRouterContext)
  const [{refs}, maximized, toggleMaximized ] = usePanelUtils2()
  const panelRef = refs.panel
  const scrollContainerRef = refs.scrollContainer
  
  useEffect(() => {
    selectedStudiesToRoute && toggleMaximized(true)
  },[])

  return <WidgetPanelComponent
    className="JS-fix-dialog-scroll" maximized={maximized} ref={panelRef}
  >
    
    <WidgetHeader onClick={toggleMaximized} onTouchStart={touchClick(toggleMaximized)}>
      <div css="margin-right:auto;display:flex;align-itens:center;">
          <WidgetIcon icon="route" />
          <h4>DICOM route</h4>
      </div>
      {maximized && <>
        <PanelButton icon="arrow-down-line"/>
      </>
      }
    </WidgetHeader>
    <WidgetBody ref={scrollContainerRef}>
      {selectedStudiesToRoute && selectedStudiesToRoute.length > 0 
        ? <FlipList>
            {selectedStudiesToRoute &&  selectedStudiesToRoute.map((study, idx) => 
                <SelectingItem key={idx} study={study} setSelectedStudiesToRoute={setSelectedStudiesToRoute} />)
            } 
          </FlipList> 
        : <div css="text-align:center;color: #B4B4B4;font-size: 15px;line-height: normal; margin: 1rem;">
          Select the studies to route
        </div>
      }
    </WidgetBody>
    <RouteWidgetFooter>
    
      <Button css={selectedStudiesToRoute.length > 0 && "max-width:110px;"} 
        onClick={() =>{
          setSelectedStudiesToRoute([])
          close()
        }}
      >
        Cancel
      </Button>
      {selectedStudiesToRoute.length > 0 && 
        <Button highlight onClick={() => togglePacsDialog.toggle()}>
          Select PACS Node
        </Button>
      }
    </RouteWidgetFooter>
  </WidgetPanelComponent>
}